import { h, Component } from 'preact'
import PropTypes from 'prop-types'
import SimpleFilterButtonsApp from '../SearchFilter/SimpleFilterButtonsApp'
import { sortItems } from '%/utils/sort'

class SimpleFilterButtons extends Component {
  render() {
    const { filterCategories, filterModels, sort, showDropdownIcon, showActiveStatus } = this.props
    return (
      <SimpleFilterButtonsApp
        filterCategories={filterCategories}
        filterModels={filterModels}
        sort={sort}
        showButtonFilter={true}
        fieldCategoryFilter="q[categories_name_in][]"
        fieldModelFilter='q[models_name_cont_any][]'
        showDropdownIcon={showDropdownIcon}
        showActiveStatus={showActiveStatus}
      />
    )
  }
}

SimpleFilterButtons.defaultProps = {
  sort: sortItems,
  showDropdownIcon: false,
  showActiveStatus: false,
}

SimpleFilterButtons.propTypes = {
  filterCategories: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  filterModels: PropTypes.array,
  showDropdownIcon: PropTypes.bool,
  showActiveStatus: PropTypes.bool,
  sort: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      paramValue: PropTypes.string,
    })
  ),
}

export default SimpleFilterButtons
